import { TrendingUpIcon } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import type { RepositoriesTrendsSnapshot } from '@/types'

import { CommitsChart } from './commits-chart'
import { WeeklyCommitsPieChart } from './weekly-commits-pie-chart'

type Trends = RepositoriesTrendsSnapshot

export function TrendsDrawer({ trends }: { trends: Trends }) {
  const [open, setOpen] = useState(false)

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button size="icon" className="hover:bg-black hover:text-golden-500" aria-label="Trends">
          <TrendingUpIcon className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent
        side="right"
        className="w-full gap-0 overflow-y-auto sm:max-w-md md:max-w-lg lg:max-w-xl"
      >
        <SheetHeader className="space-y-1.5 border-b px-6 py-6 text-left">
          <SheetTitle>Trends</SheetTitle>
          <SheetDescription>View code changes trends and weekly statistics for this project.</SheetDescription>
        </SheetHeader>
        <div className="flex flex-col gap-6 p-6">
          <CommitsChart data={trends.daily.data} trend={trends.daily.trend} />
          <WeeklyCommitsPieChart
            totalCommits={trends.weekly.totalCommits}
            trend={trends.weekly.trend}
            chartData={trends.weekly.chartData}
          />
        </div>
      </SheetContent>
    </Sheet>
  )
}
